var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "banking-information-step" },
    [
      _c("div", { staticClass: "fm-info-banner mb-4" }, [
        _c(
          "svg",
          {
            attrs: {
              fill: "currentColor",
              viewBox: "0 0 16 16",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "Your bank account details are used for disbursement of the loan funds only."
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c(
              "FormGroup",
              {
                attrs: {
                  label: "Account Name",
                  "error-container": _vm.errorContainerName,
                  name: "accountName",
                  floating: true,
                },
              },
              [
                _c("input", {
                  staticClass: "form-control",
                  attrs: { type: "text", readonly: "", placeholder: " " },
                  domProps: { value: _vm.form.accountName },
                }),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c(
              "FormGroup",
              {
                attrs: {
                  label: "BSB",
                  "error-container": _vm.errorContainerName,
                  name: "bsb",
                  floating: true,
                },
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.bsb,
                      expression: "form.bsb",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: " " },
                  domProps: { value: _vm.form.bsb },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "bsb", $event.target.value)
                    },
                  },
                }),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c(
              "FormGroup",
              {
                attrs: {
                  label: "Account Number",
                  "error-container": _vm.errorContainerName,
                  name: "accountNumber",
                  floating: true,
                },
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.accountNumber,
                      expression: "form.accountNumber",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: " " },
                  domProps: { value: _vm.form.accountNumber },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "accountNumber", $event.target.value)
                    },
                  },
                }),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm._t("controls", null, null, { prev: _vm.onPrev, next: _vm.onNext }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }